function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 160,
  rx: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5 54.5H90M.5 105.5H90",
  stroke: "#656D78",
  strokeWidth: 7,
  className: "svg-no-adaptive-fill"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 160"
  }, props), _ref);
};

export default SvgComponent;